<template>
  <div class="data" :ref="id"></div>
</template>

<script>
  export default {
    props: ['chartData', 'id', 'name'],
    data() {
      return {
        myChart: undefined,
        resizeHandler: null
      }
    },
    created() {
      this.debounceResize = _.debounce(this.resize, 200)
      this.resizeHandler = _ => {
        this.debounceResize()
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    mounted() {
      this.initEchart()
    },
    methods: {
      resize() {
        try {
          this.myChart.resize()
        } catch (e) {
          console.log(e)
        }
      },
      initEchart() {
        if (this.myChart) this.myChart.dispose()
        let dom = this.$refs[this.id]
        let myChart = this.$echarts.init(dom)
        this.myChart = myChart
        this.myChart.setOption(this.getOption())
      },
      getOption() {
        const processedIndicators = this.chartData.xdata.map(item => {
          let max = item.max || 100
          // 简单的算法：将 max 向上取整到最近的 10 的倍数，确保能被 splitNumber (3) 整除且刻度为整数
          // 例如 88 -> 90 (90/3=30), 85 -> 90
          const remainder = max % 10
          if (remainder > 0) {
            max = max + (10 - remainder)
          }
          // 如果需要严格对齐到 splitNumber (3)，可以进一步调整，例如确保 max 是 30 的倍数
          return {
            ...item,
            max: max
          }
        })
        let option
        option = {
          tooltip: {
            show: true,
            trigger: 'item',
            backgroundColor: '#012c56',
            borderWidth: 0,
            textStyle: {
              color: '#fff'
            }
          },
          legend: {
            show: false
          },
          grid: {
            top: '5%',
            left: '5%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          radar: {
            center: ['50%', '50%'],
            radius: '61%',
            startAngle: 90,
            splitNumber: 3,
            shape: 'circle',
            splitArea: {
              areaStyle: {
                color: ['transparent']
              }
            },
            axisName: {
              color: '#b3ccff'
            },
            axisNameGap: 10,
            axisLabel: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#2E77BD'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#2E77BD' //
              }
            },
            indicator: processedIndicators
          },
          series: [
            {
              name: '报备次数',
              type: 'radar',
              symbol: 'circle',
              symbolSize: 8,
              areaStyle: {
                color: new this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                  {
                    color: '#12475D',
                    offset: 0
                  },
                  {
                    color: '#103E4C',
                    offset: 1
                  }
                ])
              },
              itemStyle: {
                color: '#fff',
                borderColor: '#3decf3',
                borderWidth: 2
              },
              lineStyle: {
                type: 'solid',
                color: '#3decf3',
                width: 2
              },
              data: [this.chartData.data]
            }
          ]
        }
        return option
      },
      refresh() {
        this.myChart.clear()
        this.myChart.setOption(this.getOption())
      }
    },
    watch: {
      chartData: {
        handler() {
          this.$nextTick(() => {
            this.refresh()
          })
        },
        deep: true
        // immediate: true,
      }
    },
    destroyed() {
      if (this.myChart) this.myChart.dispose()
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }
      if (this.debounceResize && this.debounceResize.cancel) {
        this.debounceResize.cancel()
      }
    }
  }
</script>

<style lang="less" scoped>
  .data {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/leftThree/radarChart.vue